export enum PortalRoutes {
    Dashboard = '/dashboard',
    Products = '/products',
    Orders = '/orders',
    Users = '/users',
    Roles = '/roles',
    Customers = '/customers',
    ProductAnalytics = '/product-analytics',
    Audit = '/audit',
    AppHeader = '/app-header',
    Typography = '/typography',
    SplashScreen = '/splash-screen',
    ProductDetail = '/product-detail',
    RestaurantSubmissions = '/restaurant-submissions',
    // Platform Admin routes (isPlatformAdmin only)
    CustomScreens = '/custom-screens',
}
